export default {
  label_start: "Start",
  label_end: "End",
  label_start_date: "Start date",
  label_deadline: "Deadline",
  label_range_start: "Range start",
  label_range_end: "Range end",
  error_date_time: "Invalid date. Please enter a date in this format: YYYY-MM-DD HH:MM",
  error_date: "Invalid date. Please enter a date in this format: YYYY-MM-DD",
  error_time: "Invalid time. Please enter a time in this format: HH:MM",
  error_future: "Cannot select a date in the future",
  error_both: "Both start and end dates are needed",
  error_range: "Your start date needs to be before the end date",
}
